module.exports = {
  graphqlURI: process.env.GRAPHQL_URI,
  recaptchaBypass: process.env.RECAPTCHA_BYPASS,
  recaptchaSiteKeyV2: process.env.RECAPTCHA_SITEKEY_V2,
  recaptchaSiteKeyV3: process.env.RECAPTCHA_SITEKEY_V3,
  buggEmailCode: process.env.BUGG_EMAIL_CODE,
  stripeAPIKey: process.env.STRIPE_API_KEY,
};
